<template>
  <v-container
    id="passwordReset"
  >
    <v-row
      class="d-flex justify-center"
    >
      <v-col
        cols="12"
        md="8"
        class="unskew"
      >
        <v-card
          elevation="1"
          outlined
          tile
        >
          <v-card-title class="px-4">
            Reset Password
          </v-card-title>
          <v-card-text>
            <v-form
              v-model="valid"
            >
              <v-text-field
                v-model="email"
                class="textField"
                disabled
                label="Email"
                filled
                :rules="[...Rules.required, ...Rules.email]"
              />
              <v-text-field
                v-model="candidate.password"
                class="textField"
                filled
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="Create New Password"
                :rules="[
                  ...Rules.required,
                  ...Rules.password,
                  !password_match ? 'Your passwords don\'t match' : true
                ]"
                hint="Password must be a minimum of 8 characters"
                counter
                @input="checkPasswordsMatch"
                @click:append="show1 = !show1"
              />
              <v-text-field
                v-model="confirmPassword"
                class="textField"
                filled
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                name="input-10-1"
                label="Confirm Password"
                :rules="[
                  ...Rules.password,
                  !password_match ? 'Your passwords don\'t match' : true
                ]"
                counter
                @input="checkPasswordsMatch"
                @click:append="show2 = !show2"
              />
            </v-form>
            <v-alert
              :value="errors"
              type="warning"
              dense
              dismissible
            >
              {{ errors }}
            </v-alert>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-btn
              id="resetButton"
              :disabled="!valid"
              :loading="loading"
              tile
              dark
              @click="resetPassword"
            >
              Reset Password
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'PasswordReset',
  props: {
    email: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    },
    candidate: {
      type: Object,
      default: () => {
        return {
          password: ''
        }
      }
    },
    iscandidate: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    show1: false,
    show2: false,
    timeout: '',
    password_match: false,
    valid: false,
    loading: false,
    confirmPassword: '',
    errors: null
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    checkPasswordsMatch () {
      const context = this
      clearTimeout(context.timeout)
      context.timeout = setTimeout(function () {
        context.password_match = context.candidate.password === context.confirmPassword
      }, 500)
    },
    resetPassword () {
      this.loading = true
      const resetUrl = this.URLs.core.auth.passwordReset
      const loginUrl = this.URLs.core.auth.login
      axios.post(resetUrl, {
        token: this.token,
        email: this.email,
        password: this.candidate.password,
        password_confirmation: this.confirmPassword
      })
        .then(() => {
          axios.post(loginUrl, {
            email: this.email,
            password: this.candidate.password
          })
        })
        .catch(error => {
          this.errors = error.response.data.errors
          this.loading = false
        })
        .finally(() => {
          const wl = window.location
          wl.href = wl.protocol + '//' + wl.hostname + '/dashboard'
        })
    }
  }
}
</script>
<style lang="scss">
@import './resources/sass/variables';
@import './resources/sass/agencyTheming';
#passwordReset {
  #resetButton{
    background-color: $agencyColorPrimary;
    &.v-btn--disabled {
      background-color: $agencyColorLightFaded!important;
      color: lightgrey;
    }
  }
  .unskew{
    max-width: 500px;
    transform: skewY(-10deg);
    color: white;
  @media screen and (min-width: 960px){
      transform: skewX(15deg);
      margin: 1rem 1rem;
      padding: 1rem 1rem;
    }
  }
}
</style>
